<template>
    <KillerSplashPlayer
        :player="player"
        :color="color"
        :title="$t('killer.you_are_killer')"
        :hint="$t('killer.killer_instructions')"
        is-killer
    />
</template>

<script>
import KillerSplashPlayer from './KillerSplashPlayer.vue'

export default {
    name: 'KillerSplashBecameKiller',
    components: { KillerSplashPlayer },
    props: {
        player: {
            type: Object,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
}
</script>
